export const getRouterId = (path = []) => {
    const arr  = path.split('/');
    return arr[arr.length - 1];
}

export const getUrlWithRole = () => {
    const pathName = location.pathname || null;


    if(!pathName) return '';
    
    const arr = pathName.split('/');
    const role = arr[1];

    if(role === 'admin') return '';
    return `${role}/`;
}

export const getRole = () => {
    const pathName = location.pathname || null;

    if(!pathName) return 'admin';

    const arr = pathName.split('/');
    return arr[1];
}